import { useState } from 'react';
import {
  Center, Paper, Title, TextInput, PasswordInput, Button, Alert, Stack, Text,
} from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useAuth } from '../auth/AuthContext';

export function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(username, password);
    setLoading(false);
    if (!result.success) setError(result.error || 'Login failed');
  };

  return (
    <Center h="100vh" bg="var(--mantine-color-body)">
      <Paper shadow="md" p="xl" radius="md" w={400}>
        <form onSubmit={handleSubmit}>
          <Stack>
            <Title order={2} ta="center">Claudia</Title>
            <Text c="dimmed" ta="center" size="sm">Risky Business Consulting</Text>
            {error && (
              <Alert icon={<IconAlertCircle size={16} />} color="red" variant="light">
                {error}
              </Alert>
            )}
            <TextInput
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.currentTarget.value)}
              required
            />
            <PasswordInput
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              required
            />
            <Button type="submit" loading={loading} fullWidth>
              Sign in
            </Button>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
